import { Toaster } from 'sonner';
import { useTranslation } from 'react-i18next';

import { useKeycloak } from './keycloak/KeycloakProvider';
import { Routes } from './pages/routes';

export const App = () => {
  const { t } = useTranslation();
  const { initialized } = useKeycloak();

  if (!initialized) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-text-muted">{t('common.loading')}</p>
      </div>
    );
  }

  return (
    <>
      <Routes />
      <Toaster position="top-right" />
    </>
  );
};
